
import {Vue, Component, Prop} from 'vue-property-decorator';
import api from '@reserve/api';
import * as types from '@account/store/types';
import { mapGetters } from 'vuex';
import axios from 'axios';

//components
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue';

//util
import DatePicker from '@appbase/components/DatePicker/DatePicker.vue';
import myReserve from "@reserve/api/myReserve";
import * as dateutil from "@appbase/util/date-helper";
import {IEDate, uGetDateFormat} from "@appbase/util/date-helper";

interface TableColumn {
    Width: string;
    Label: string;
    Key: string;
}

interface TableRow {
    type: string;
    date: string;
    roomName: string;
    title: string;
    state: string;
    registerDate: string;
}

@Component({
    name: 'MyReserveList',
    components: { DatePicker, PageNavigationBar },
    computed: {
        ...mapGetters({
            user: types.USER,
        }),
    },
})

export default class MigDocumentList extends Vue {
    @Prop({ type: Boolean, default: false }) isPopup!: boolean;

    user!: account.TUser;
    pageRange: number = 10;
    itemsPerPage: number = 20;
    currentPage: number = 1;
    totalPage: number = 1;
    totalCount: number = 0;

    searchValue: string = '';
    searchStartDate: string = '';
    searchEndDate: string = '';
    searchType :  string = '';
    searchState : string = '';

    list: TableColumn[] = [
        { Width: '150px', Label: this.$t('구분') as string, Key: 'type' },
        { Width: '300px', Label: this.$t('자원명') as string, Key: 'roomName' },
        { Width: '400px', Label: this.$t('예약일시') as string, Key: 'date' },
        { Width: '300px', Label: this.$t('제목') as string, Key: 'title' },
        { Width: '150px', Label: this.$t('상태') as string, Key: 'state'},
        { Width: '300px', Label: this.$t('등록일자') as string, Key: 'registerDate' }
    ];

    // 조회 리스트
    myReserveList : myReserve.TA_CALENDAR_MY_EVENT[] = [];

    mounted() {
        const today = new Date();
        const before30Days = new Date(today.getTime() - 1000 * 60 * 60 * 24 * 30);
        const after30Days = new Date(today.getTime() + 1000 * 60 * 60 * 24 * 30);

        this.searchStartDate = this.formatDate(before30Days);
        this.searchEndDate = this.formatDate(after30Days);

        this.getSearchMyReserveList();
    }

    formatDate(date: Date): string {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    // 내예약 조회
    async getSearchMyReserveList(){
        // 검색 조건 수정
        let searchData :myReserve.MY_RESERVE_SEARCH =
            {
                pageRange: this.pageRange,
                itemsPerPage: this.itemsPerPage,
                currentPage: this.currentPage,
                totalPage: this.totalPage, // 초기값으로 0 또는 적절한 기본값
                totalCount: this.totalCount, // 초기값으로 0 또는 적절한 기본값
                searchStartDate:  this.searchStartDate,
                searchEndDate: this.searchEndDate,
                type: this.searchType === '' ? null : this.searchType,
                state: this.searchState === '' ? null : this.searchState,
                keyword: this.searchValue === '' ? null : this.searchValue,
                personId : this.user.personId,
                email : this.user.email
            }
        this.myReserveList = await myReserve.getMyReserve(searchData);
        console.log("gs",this.myReserveList)
        console.log("gs", this.myReserveList[0].totalCount)
        this.totalCount = this.myReserveList.length>0 ? this.myReserveList[0].totalCount : 0;
    }

    //날짜 형식 변환
    setDisplayDate(date: Date, dateFormat: string){
        if (date === null) return "";
        return uGetDateFormat('yyyy-MM-dd H:i:s', IEDate(date));
    }

    /**
     * 페이지 번호 클릭 시 호출됩니다.
     * @param pageNum
     */
    async pageMove(pageNum: number) {
        this.currentPage = pageNum;
      await  this.getSearchMyReserveList();
    }


}